var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "gauge-body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,0C179.1,0,0,179.1,0,400s179.1,400,400,400,400-179.1,400-400S620.9,0,400,0ZM400,700c-165.6,0-300-134.4-300-300S234.4,100,400,100s300,134.4,300,300-134.4,300-300,300ZM400,150c-121,0-221.9,85.9-245,200h57.1c8.6-32.8,25.7-62.8,50.4-87.5,36.7-36.7,85.6-56.9,137.5-56.9s100.8,20.1,137.5,56.9c24.7,24.7,41.8,54.7,50.4,87.5h57c-23.1-114.1-124-200-245-200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "gauge-pin",
    d: "M228.3,328.7l96.5,136.1c-1.9,14.1,0,28.8,6.6,42.6,17.8,37.4,62.5,53.3,99.9,35.6s53.3-62.5,35.6-99.9-54.5-50.2-89.4-39.7l-149.1-74.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.60b64977d6a4409312e08312f3ef5db8.svg";
export { ForwardRef as ReactComponent };